export var YM_GOALS_NAV = {
    'https://center.samoletgroup.ru/event-cards/plan': 'click_plan',
    'https://rri.samoletgroup.ru/': 'click_rri',
    'https://sc.samoletgroup.ru/reports': 'click_reports',
    'https://pro.samoletgroup.ru/': 'click_pro',
    'https://standards.samoletgroup.ru/structure-of-standards': 'click_standards',
    'https://calendar.samoletgroup.ru/': 'click_calendar',
    'https://srmproposals.samoletgroup.ru/': 'click_srmproposals',
};
//# sourceMappingURL=constants.js.map